import React from "react"
import { Typography } from "@mui/material"

export const WithPreventEmbed = ({ children } : { children: React.ReactNode }) => (
  window.location && window.top && window.top.location !== window.location
    ? (
      <Typography>Embedding disabled for this page</Typography>
    )
    : <>{children}</>
)